import type { PropType } from 'virtual-vue';
import type { ToastIconType } from './toast';

/**
 * 组件的props
 */
export const props = {
  /**
   * 是否显示,调用辅助函数 showToast/hideToast 可不传入
   * @default false
   */
  visible: {
    type: Boolean,
    default: false,
  },
  /**
   * 图标类型
   * @default 'text'
   */
  icon: {
    type: [String, Object] as PropType<ToastIconType>,
    default: 'text',
  },
  /**
   * 提示内容
   */
  message: {
    type: String,
    required: true,
  },
  /**
   * 显示时长（毫秒）
   * @default 2000
   */
  duration: {
    type: Number,
    default: 2000,
  },
  /**
   * 是否显示底部loading
   * @default false
   */
  showDotLine: {
    type: Boolean,
    default: false,
  },
  /**
   * 是否自动关闭 Toast
   * @default true
   */
  autoHide: {
    type: Boolean,
    default: true,
  },
};
